export const CREATE_EVENT_CTA_CLICK =
    'Consumer Header - Create Event CTA - Button - Click ';
export const FIND_EVENT_CTA_CLICK =
    'Consumer Header - Find Event CTA - Button - Click ';
